/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { Country } from '@app/settings/countries/countries.model';
import { CitiesSeo } from '@app/settings/cities/cities-seo.model';

export class City extends Model {
  id: number;
  name: string;
  alternatenames: string;
  lat: number;
  long: number;
  timezone: string;
  active: boolean;
  country_id: number;
  country?: Country;
  translations?: Array<CitiesSeo>;

  get fullName(): String {
    if (this.country && this.country.name) {
      return this.name + ' (' + this.country.name + ')';
    }
    return this.name;
  }

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.country) {
      this.country = new Country().deserialize(input.country);
    }
    return this;
  }
}
